/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type GetInferenceSpendCapsSecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type GetInferenceSpendCapsRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
};

/** @internal */
export type GetInferenceSpendCapsSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const GetInferenceSpendCapsSecurity$outboundSchema: z.ZodMiniType<
  GetInferenceSpendCapsSecurity$Outbound,
  GetInferenceSpendCapsSecurity
> = z.pipe(
  z.object({
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function getInferenceSpendCapsSecurityToJSON(
  getInferenceSpendCapsSecurity: GetInferenceSpendCapsSecurity,
): string {
  return JSON.stringify(
    GetInferenceSpendCapsSecurity$outboundSchema.parse(
      getInferenceSpendCapsSecurity,
    ),
  );
}

/** @internal */
export type GetInferenceSpendCapsRequest$Outbound = {
  "Gram-Session"?: string | undefined;
};

/** @internal */
export const GetInferenceSpendCapsRequest$outboundSchema: z.ZodMiniType<
  GetInferenceSpendCapsRequest$Outbound,
  GetInferenceSpendCapsRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
    });
  }),
);

export function getInferenceSpendCapsRequestToJSON(
  getInferenceSpendCapsRequest: GetInferenceSpendCapsRequest,
): string {
  return JSON.stringify(
    GetInferenceSpendCapsRequest$outboundSchema.parse(
      getInferenceSpendCapsRequest,
    ),
  );
}
